// extracted by mini-css-extract-plugin
export var heading = "Manifesto-module--heading--98b6a";
export var item = "Manifesto-module--item--a11b7";
export var items = "Manifesto-module--items--9b625";
export var section = "Manifesto-module--section--9fc41";